export default {
  isMIPIH: false,
};



// WEBPACK FOOTER //
// ./src/store/modules/conf/state.js